export default "__VITE_ASSET__NkAFXWGr__"